import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { showArticle } from '@intercom/messenger-js-sdk';
import { SearchHitHighlightOrDocumentValue } from 'components/search/SearchHitHighlightOrDocumentValue';
import * as SearchResults from 'components/search/SearchResults';
import { useSearchStore } from 'components/search/useSearchStore';

const SearchHelpCenterResults = () => {
    const { setIsOpen } = useSearchStore();
    const { isEmpty, getKey, data } = SearchResults.useSearchResultsProps('help_center');

    if (isEmpty) {
        return null;
    }

    return (
        <SearchResults.Root>
            <SearchResults.Title>Help Center</SearchResults.Title>
            {data.hits.map(hit => {
                return (
                    <SearchResults.ListItem
                        key={getKey(hit.document.id)}
                        onClick={() => {
                            setIsOpen(false);
                            return showArticle(hit.document.id);
                        }}
                        className={'items-start'}
                    >
                        <SearchResults.Icon icon={faQuestionCircle} />
                        <div className={'flex flex-col gap-1'}>
                            <SearchHitHighlightOrDocumentValue
                                hit={hit}
                                documentKey={'title'}
                                className={'font-medium leading-none'}
                            />
                            <SearchHitHighlightOrDocumentValue
                                hit={hit}
                                documentKey={'description'}
                                className={'text-gray-500'}
                            />
                        </div>
                    </SearchResults.ListItem>
                );
            })}
        </SearchResults.Root>
    );
};

export { SearchHelpCenterResults };
